import { BASE_QUERY_PRO, ruleNewsPlus } from '../shared/configs';

enum SECTION_ENUM {
  COMMENTARY_AND_ANALYSIS = 'Commentary & Analysis',
  DEALS_AND_EXISTS = 'Deals & Exits',
  INDUSTRY_NEWS = 'Industry News & Limited Partners',
  FIRMS_AND_FUNDS = 'Firms & Funds'
}

const baseQuery = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    and: [...BASE_QUERY_PRO.query.and, { terms: { key: 'ContentType', value: ['article'] } }]
  }
};

const SECTION_TOP = {
  ...baseQuery,
  query: {
    ...baseQuery.query,
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [
            'pro pe deals',
            'pro pe exits',
            'pro pe industry news',
            'pro pe legal regulatory',
            'pro pe limited partners',
            'pro pe commentary analysis'
          ]
        }
      }
    ],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP_SIX = {
  ...baseQuery,
  query: {
    ...baseQuery.query,
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [
            'pro pe deals',
            'pro pe exits',
            'pro pe industry news',
            'pro pe legal regulatory',
            'pro pe limited partners'
          ]
        }
      }
    ],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

const COMMENTARY_AND_ANALYSIS = {
  ...baseQuery,
  query: { ...baseQuery.query, or: [{ terms: { key: 'SectionType', value: ['pro pe commentary analysis'] } }] }
};

const DEALS_AND_EXISTS = {
  ...baseQuery,
  query: { ...baseQuery.query, or: [{ terms: { key: 'SectionType', value: ['pro pe deals', 'pro pe exits'] } }] }
};

const INDUSTRY_NEWS = {
  ...baseQuery,
  query: {
    ...baseQuery.query,
    or: [
      {
        terms: {
          key: 'SectionType',
          value: ['pro pe industry news', 'pro pe legal regulatory', 'pro pe limited partners']
        }
      }
    ]
  }
};

const FIRMS_AND_FUNDS = {
  ...baseQuery,
  query: { ...baseQuery.query, or: [{ terms: { key: 'SectionType', value: ['pro pe fund news', 'pro pe people'] } }] }
};

const MORE_LIST = {
  ...SECTION_TOP
};

export {
  SECTION_TOP,
  SECTION_TOP_SIX,
  COMMENTARY_AND_ANALYSIS,
  DEALS_AND_EXISTS,
  INDUSTRY_NEWS,
  FIRMS_AND_FUNDS,
  MORE_LIST,
  SECTION_ENUM
};
